import styled, { css } from "../../__compat__/styled-components/main.entry.mjs.mjs";
import { injectTypography } from "../../utils/injectTypography.mjs.mjs";
import { injectSpacing } from "../../api/spacing/injectSpacing.mjs.mjs";
import { injectOSXFontSmoothing } from "../../utils/injectOSXFontSmoothing.mjs.mjs";
const getTextColor = (props) => {
    switch (props.variant) {
        case 'invalid':
            return props.theme.colors.ui.error;
        default:
            return props.theme.colors.ui.tertiary;
    }
};
export const StyledErrorIcon = styled.svg.withConfig({ displayName: "auir-611444a-StyledErrorIcon", componentId: "auir-611444a-1wmd2pd" }) `
  display: inline-flex;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  margin-block-start: -0.5ex;
  margin-inline-end: var(${(props) => props.theme.responsive.spacing.xs});
`;
export const StyledErrorIconPath = styled.path.withConfig({ displayName: "auir-611444a-StyledErrorIconPath", componentId: "auir-611444a-1ah6o5x" }) `
  fill: none;
  fill-rule: evenodd;
  stroke: currentColor;
  stroke-width: 1;
`;
export const StyledFormHelperText = styled.div.withConfig({ displayName: "auir-611444a-StyledFormHelperText", componentId: "auir-611444a-1clqj8y" }) `
  display: flex;
  ${(props) => props.variant === 'invalid' &&
    css `
      padding-block-start: 0.5ex;
    `}

  color: var(${(props) => getTextColor(props)});

  ${(props) => injectTypography(props, 'copy2')}
  ${injectOSXFontSmoothing(true)}
  ${injectSpacing('margin')}
`;
//# sourceMappingURL=FormHelperText.styles.mjs.mjs.map